(function () {
  function imageSetValue(value) {
    return String(value || '').toLowerCase().replace(
      new RegExp(String.fromCharCode(92) + 's+', 'g'),
      '-'
    );
  }

  function imageGroupFromAlt(alt) {
    var match = String(alt || '').trim().match(
      new RegExp('^#([^' + String.fromCharCode(92) + 's]+)$')
    );

    if (!match) return '';

    return imageSetValue(match[1]);
  }

  function applyGalleryFix(refreshSelection) {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
    var groupedMedia = Array.prototype.slice.call(
      section.querySelectorAll('[data-set-name][data-group]')
    );

    if (!groupedMedia.length) return;

    var setName = groupedMedia[0].dataset.setName;
    var variantJson = section.querySelector('[data-variant-json]');
    var variants = [];
    var sourceGroups = [];
    var optionWrap;
    var optionWrapScore = 0;
    var sourceToLocalizedGroup = {};

    if (variantJson) {
      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        variants = [];
      }
    }

    groupedMedia.forEach(function (media) {
      var image = media.querySelector('img');
      var sourceGroup = image && imageGroupFromAlt(image.getAttribute('alt'));

      if (sourceGroup && sourceGroups.indexOf(sourceGroup) === -1) {
        sourceGroups.push(sourceGroup);
      }
    });

    Array.prototype.slice.call(
      section.querySelectorAll('.variant-input-wrap')
    ).forEach(function (wrap) {
      var matchedGroups = [];

      Array.prototype.slice.call(
        wrap.querySelectorAll('[data-variant-input]')
      ).forEach(function (input) {
        var optionKey = input.dataset.index;
        var variant = variants.find(function (candidate) {
          var sourceGroup = candidate.featured_image &&
            imageGroupFromAlt(candidate.featured_image.alt);

          return String(candidate[optionKey]) === input.value &&
            sourceGroups.indexOf(sourceGroup) !== -1;
        });
        var sourceGroup = variant &&
          imageGroupFromAlt(variant.featured_image.alt);

        if (sourceGroup && matchedGroups.indexOf(sourceGroup) === -1) {
          matchedGroups.push(sourceGroup);
        }
      });

      if (matchedGroups.length > optionWrapScore) {
        optionWrap = wrap;
        optionWrapScore = matchedGroups.length;
      }
    });

    if (!optionWrap) return;

    var optionInputs = Array.prototype.slice.call(
      optionWrap.querySelectorAll('[data-variant-input]')
    );
    var optionGroups = optionInputs.map(function (input) {
      return setName + '_' + imageSetValue(input.value);
    });

    Array.prototype.slice.call(
      section.querySelectorAll('[data-locale-gallery-fallback]')
    ).forEach(function (media) {
      var optionIndex = Number(media.dataset.localeGalleryFallbackIndex);

      if (optionGroups[optionIndex]) {
        media.dataset.group = optionGroups[optionIndex];
      }
    });

    optionInputs.forEach(function (input) {
      var optionKey = input.dataset.index;
      var variant = variants.find(function (candidate) {
        return String(candidate[optionKey]) === input.value &&
          candidate.featured_image &&
          imageGroupFromAlt(candidate.featured_image.alt);
      });

      if (!variant) return;

      sourceToLocalizedGroup[imageGroupFromAlt(variant.featured_image.alt)] =
        setName + '_' + imageSetValue(input.value);
    });

    groupedMedia.forEach(function (media) {
      if (media.dataset.localeGalleryFallback === 'true') return;

      var image = media.querySelector('img');
      var sourceGroup = image && imageGroupFromAlt(image.getAttribute('alt'));
      var localizedGroup = sourceToLocalizedGroup[sourceGroup] ||
        sourceToLocalizedGroup[media.dataset.group];

      if (localizedGroup) {
        media.dataset.group = localizedGroup;
      }
    });

    var presentGroups = [];
    groupedMedia.forEach(function (media) {
      if (presentGroups.indexOf(media.dataset.group) === -1) {
        presentGroups.push(media.dataset.group);
      }
    });

    var fallbackMedia = groupedMedia
      .filter(function (media) {
        return media.dataset.localeGalleryFallback !== 'true' &&
          media.dataset.group === presentGroups[0];
      })
      .map(function (media) {
        return {
          parent: media.parentNode,
          node: media.cloneNode(true)
        };
      });

    optionGroups.forEach(function (optionGroup, optionIndex) {
      if (presentGroups.indexOf(optionGroup) !== -1) return;

      fallbackMedia.forEach(function (media) {
        var clone = media.node.cloneNode(true);
        clone.dataset.group = optionGroup;
        clone.dataset.localeGalleryFallback = 'true';
        clone.dataset.localeGalleryFallbackIndex = String(optionIndex);
        clone.classList.remove('starting-slide');
        media.parent.appendChild(clone);
      });
    });

      if (refreshSelection) {
        var checkedInput = optionWrap.querySelector('[data-variant-input]:checked');

        if (checkedInput) {
          checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  applyGalleryFix(false);
  setTimeout(function () { applyGalleryFix(true); }, 300);
  setTimeout(function () { applyGalleryFix(true); }, 1500);

  function applyAfterLoad() {
    applyGalleryFix(true);
    setTimeout(function () { applyGalleryFix(true); }, 500);
  }

  if (document.readyState === 'complete') {
    applyAfterLoad();
  } else {
    window.addEventListener('load', applyAfterLoad);
  }

  document.querySelectorAll(
    '[data-section-type="product"] .variant-input-wrap'
  ).forEach(function (wrap) {
    var translationTimer;
    var translationObserver = new MutationObserver(function () {
      clearTimeout(translationTimer);
      translationTimer = setTimeout(function () {
        applyGalleryFix(true);
      }, 50);
    });

    translationObserver.observe(wrap, {
      attributes: true,
      attributeFilter: ['value'],
      childList: true,
      characterData: true,
      subtree: true
    });
  });
})();
